import {
  faTennisBall,
  faBox,
  faShower,
  faEye,
  faSyringe,
  faBone,
  faBugs,
  faHorseHead,
  faCarrot,
  faStaffSnake,
  faAtomSimple,
} from "@fortawesome/pro-thin-svg-icons";

import Icon from "common/components/Icon";

type SVGProps = { className?: string };

const CategoryContentLookup: {
  [key: string]: {
    Icon: React.FC<SVGProps>;
    Blob: React.FC<SVGProps>;
    gradient: { start: string; stop: string };
  };
} = {
  "flea-tick": {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 97 86" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M32.5645 24.5312H37.5449L41.0312 17.3926C41.3633 16.7285 42.1934 16.3965 42.8574 16.7285C43.5215 17.0605 43.8535 17.8906 43.5215 18.5547L39.5371 26.5234C39.2051 27.0215 38.873 27.1875 38.375 27.1875H33.0625V37.1484L41.5293 42.1289C42.0273 42.2949 42.1934 42.627 42.1934 42.959L43.5215 52.2559C43.6875 53.0859 43.1895 53.75 42.5254 53.75C41.6953 53.916 41.0312 53.418 41.0312 52.7539L39.7031 43.9551L32.7305 39.9707C31.7344 44.9512 27.418 48.4375 22.4375 48.4375C17.291 48.4375 12.9746 44.9512 11.9785 39.9707L5.00586 43.9551L3.67773 52.7539C3.67773 53.418 3.01367 53.916 2.18359 53.75C1.51953 53.75 1.02148 53.0859 1.1875 52.2559L2.51562 42.959C2.51562 42.627 2.68164 42.2949 3.17969 42.1289L11.8125 37.1484V27.1875H6.5C5.83594 27.1875 5.50391 27.0215 5.17188 26.5234L1.1875 18.5547C0.855469 17.8906 1.1875 17.0605 1.85156 16.7285C2.51562 16.3965 3.3457 16.7285 3.67773 17.3926L7.16406 24.5312H12.1445C12.8086 21.377 15.1328 18.7207 18.1211 17.5586L11.8125 2.61719C11.4805 1.95312 11.8125 1.12305 12.4766 0.791016C13.1406 0.458984 13.9707 0.791016 14.3027 1.45508L20.7773 16.7285C21.2754 16.7285 21.7734 16.5625 22.4375 16.5625C22.9355 16.5625 23.4336 16.7285 23.9316 16.7285L30.4062 1.45508C30.7383 0.791016 31.5684 0.458984 32.2324 0.791016C32.8965 1.12305 33.2285 1.95312 32.8965 2.61719L26.5879 17.5586C29.5762 18.7207 31.9004 21.377 32.5645 24.5312ZM14.4688 37.9785C14.4688 42.2949 17.9551 45.7812 22.4375 45.7812C26.7539 45.7812 30.2402 42.2949 30.4062 37.9785V27.1875C30.4062 22.8711 26.7539 19.2188 22.4375 19.2188C17.9551 19.2188 14.4688 22.8711 14.4688 27.1875V37.9785ZM58.1309 58.2324H49.9961L44.6836 65.2051C44.1855 65.7031 43.3555 65.8691 42.8574 65.3711C42.1934 64.873 42.0273 64.043 42.5254 63.5449L48.3359 56.0742C48.668 55.7422 49 55.5762 49.332 55.5762H59.293L64.2734 47.1094L59.625 44.4531C59.293 44.2871 58.9609 43.7891 58.9609 43.291L59.625 34.3262C59.625 33.6621 60.2891 32.998 60.9531 33.1641C61.6172 33.1641 62.2812 33.8281 62.1152 34.4922L61.7832 42.627L65.9336 44.9512C68.2578 42.627 71.5781 41.4648 74.7324 41.9629L76.7246 25.6934C76.8906 25.0293 77.5547 24.5312 78.2188 24.6973C78.8828 24.6973 79.3809 25.3613 79.3809 26.0254L77.3887 42.4609C77.8867 42.793 78.3848 42.959 78.7168 43.291C79.2148 43.457 79.7129 43.7891 80.0449 44.1211L93.3262 34.1602C93.9902 33.6621 94.8203 33.8281 95.1523 34.4922C95.6504 34.9902 95.4844 35.8203 94.9863 36.3184L82.0371 46.1133C83.8633 48.6035 84.5273 52.0898 83.6973 55.2441L87.8477 57.7344L94.6543 53.252C95.3184 52.7539 96.1484 52.9199 96.4805 53.584C96.8125 54.248 96.6465 55.0781 96.1484 55.4102L88.6777 60.3906C88.1797 60.5566 87.6816 60.7227 87.3496 60.3906L82.7012 57.7344L77.7207 66.2012L82.7012 74.834C83.0332 75.166 83.0332 75.6641 82.8672 75.9961L79.3809 84.7949C79.0488 85.459 78.2188 85.791 77.5547 85.459C76.8906 85.127 76.5586 84.4629 76.8906 83.7988L80.2109 75.6641L76.0605 68.6914C72.7402 72.3438 67.2617 73.3398 62.7793 70.8496C58.4629 68.1934 56.4707 63.0469 58.1309 58.2324ZM80.377 56.4062C82.5352 52.5879 81.207 47.7734 77.3887 45.6152C73.5703 43.291 68.7559 44.6191 66.5977 48.4375L61.2852 57.7344C59.127 61.5527 60.2891 66.3672 64.1074 68.5254C67.9258 70.6836 72.9062 69.5215 75.0645 65.7031L80.377 56.4062Z"
          fill="#CC7E5C"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#FEF5F2"
        />
      </svg>
    ),
    gradient: {
      start: "#FFEAE9",
      stop: "#FEF5F2",
    },
  },
  "allergy-relief": {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 75 76" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M67.9688 33.1874H65.625C64.8926 33.1874 64.4531 33.7733 64.4531 34.3593C64.4531 35.0917 64.8926 35.5311 65.625 35.5311H67.9688C70.459 35.5311 72.6562 37.7284 72.6562 40.2186V56.6249H2.34375V40.2186C2.34375 37.7284 4.39453 35.5311 7.03125 35.5311H9.375C9.96094 35.5311 10.5469 35.0917 10.5469 34.3593C10.5469 33.7733 9.96094 33.1874 9.375 33.1874H7.03125C3.07617 33.1874 0 36.41 0 40.2186V70.6874C0 73.3241 2.05078 75.3749 4.6875 75.3749H70.3125C72.8027 75.3749 75 73.3241 75 70.6874V40.2186C75 36.41 71.7773 33.1874 67.9688 33.1874ZM72.6562 70.6874C72.6562 72.0057 71.4844 73.0311 70.3125 73.0311H4.6875C3.36914 73.0311 2.34375 72.0057 2.34375 70.6874V58.9686H72.6562V70.6874ZM18.75 44.9061H56.25C56.6895 44.9061 57.1289 44.6132 57.2754 44.1737L66.6504 16.0487C66.7969 15.7557 66.7969 15.3163 66.5039 15.0233C66.3574 14.7303 65.918 14.4374 65.625 14.4374H49.5117C45.5566 14.4374 42.1875 11.9471 40.8691 8.28503C39.2578 3.59753 35.0098 0.374878 30.0293 0.374878H9.375C8.93555 0.374878 8.64258 0.667847 8.34961 0.814331C8.20312 1.1073 8.05664 1.54675 8.20312 1.83972L17.5781 44.0272C17.7246 44.6132 18.1641 44.9061 18.75 44.9061ZM30.0293 2.71863C33.9844 2.71863 37.3535 5.35535 38.6719 9.01746C40.2832 13.705 44.5312 16.7811 49.5117 16.7811H63.8672L55.3711 42.5624H19.6289L10.6934 2.71863H30.0293Z"
          fill="#F3DE7F"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="175"
        height="175"
        viewBox="0 0 175 175"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.569606 69.0048C2.70698 52.3496 9.66306 35.8967 22.006 24.7335C34.1055 13.7904 51.2402 12.6031 67.0437 8.88434C83.228 5.07597 99.7526 -2.69202 115.513 2.73016C131.432 8.20713 140.806 24.1029 150.916 37.7405C161.114 51.4967 173.273 65.1591 174.502 82.3045C175.734 99.4885 165.782 114.836 157.521 129.858C149.281 144.844 141.74 161.647 126.632 169.363C111.636 177.023 93.7883 173.966 77.2499 170.858C62.0147 167.996 47.5126 162.245 35.5372 152.245C23.8618 142.496 16.342 129.158 10.4156 115.05C4.21781 100.296 -1.46817 84.884 0.569606 69.0048Z"
          fill="#FFFCEC"
        />
      </svg>
    ),
    gradient: {
      start: "#FFF8CD",
      stop: "#FFFCEC",
    },
  },
  "anxiety-behavior": {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 75 76" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M4.6875 66C2.05078 66 0 68.1973 0 70.6875C0 73.3242 2.05078 75.375 4.6875 75.375C7.17773 75.375 9.375 73.3242 9.375 70.6875C9.375 68.1973 7.17773 66 4.6875 66ZM4.6875 73.0312C3.36914 73.0312 2.34375 72.0059 2.34375 70.6875C2.34375 69.5156 3.36914 68.3438 4.6875 68.3438C5.85938 68.3438 7.03125 69.5156 7.03125 70.6875C7.03125 72.0059 5.85938 73.0312 4.6875 73.0312ZM21.0938 56.625C17.1387 56.625 14.0625 59.8477 14.0625 63.6562C14.0625 67.6113 17.1387 70.6875 21.0938 70.6875C24.9023 70.6875 28.125 67.6113 28.125 63.6562C28.125 59.8477 24.9023 56.625 21.0938 56.625ZM21.0938 68.3438C18.457 68.3438 16.4062 66.293 16.4062 63.6562C16.4062 61.166 18.457 58.9688 21.0938 58.9688C23.584 58.9688 25.7812 61.166 25.7812 63.6562C25.7812 66.293 23.584 68.3438 21.0938 68.3438ZM56.25 12.0938C55.6641 12.0938 55.2246 12.2402 54.7852 12.2402C52.002 5.20898 45.1172 0.375 37.5 0.375C29.8828 0.375 22.998 5.0625 20.2148 12.0938C19.6289 11.9473 19.1895 11.9473 18.75 11.9473C8.34961 11.9473 0 20.2969 0 30.6973C0 41.0977 8.34961 49.4473 18.75 49.4473C20.5078 49.4473 22.4121 49.1543 24.3164 48.5684C26.6602 53.5488 31.7871 56.7715 37.5 56.7715C43.0664 56.7715 48.0469 53.6953 50.5371 48.7148C52.4414 49.3008 54.3457 49.5938 56.25 49.5938C66.5039 49.5938 75 41.2441 75 30.9902C75 20.5898 66.5039 12.0938 56.25 12.0938ZM56.25 47.25C54.1992 47.25 52.2949 46.957 50.3906 46.2246C49.8047 45.9316 49.0723 46.2246 48.7793 46.8105C46.875 51.498 42.4805 54.4277 37.5 54.4277C32.373 54.4277 27.832 51.3516 25.9277 46.6641C25.7812 46.2246 25.3418 45.9316 24.9023 45.9316C24.7559 45.9316 24.6094 45.9316 24.4629 45.9316C22.5586 46.6641 20.6543 47.1035 18.75 47.1035C9.66797 47.1035 2.34375 39.7793 2.34375 30.6973C2.34375 21.6152 9.66797 14.291 18.75 14.291C19.1895 14.291 19.7754 14.4375 20.3613 14.4375H20.8008C21.3867 14.584 21.8262 14.291 21.9727 13.7051C24.3164 7.25977 30.4688 2.71875 37.5 2.71875C44.3848 2.71875 50.6836 7.25977 52.8809 13.998C53.0273 14.4375 53.6133 14.7305 54.1992 14.7305L54.6387 14.584C55.0781 14.584 55.6641 14.4375 56.25 14.4375C65.1855 14.4375 72.6562 21.9082 72.6562 30.8438C72.6562 39.9258 65.1855 47.25 56.25 47.25Z"
          fill="#9BB97E"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="166"
        height="178"
        viewBox="0 0 166 178"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.8747 33.3613C19.8501 19.1695 33.1073 7.19734 49.0113 2.29582C64.6018 -2.50905 80.6331 3.65569 96.5277 6.9636C112.805 10.3512 131.065 10.2939 143.057 21.8681C155.17 33.5592 156.949 51.9274 160.349 68.5597C163.778 85.3367 169.025 102.857 162.893 118.916C156.748 135.011 141.243 144.715 127.408 154.84C113.607 164.939 99.6715 176.981 82.7182 177.591C65.8905 178.195 51.0059 167.883 37.3301 158.078C24.732 149.045 14.0186 137.704 7.39075 123.58C0.928932 109.811 -0.250136 94.5445 0.340323 79.254C0.957827 63.2632 2.31752 46.8918 10.8747 33.3613Z"
          fill="#F5FAF0"
        />
      </svg>
    ),
    gradient: {
      start: "rgba(225, 237, 210, 0.79)",
      stop: "#F5FAF0",
    },
  },
  compounds: {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M40.2734 24.6819C40.4199 24.6819 40.7129 24.6819 41.0059 24.5354L67.8125 4.32056C68.8379 3.58813 70.3027 3.44165 71.4746 4.02759C72.5 4.61353 73.2324 5.49243 73.3789 6.66431C73.5254 7.83618 73.2324 8.86157 72.3535 9.74048L59.3164 22.7776C58.877 23.217 58.877 23.9495 59.3164 24.3889C59.7559 24.8284 60.4883 24.8284 61.0742 24.3889L74.1113 11.3518C75.4297 10.0334 76.0156 8.12915 75.7227 6.22485C75.4297 4.32056 74.2578 2.85571 72.5 1.97681C70.4492 0.951416 68.1055 1.0979 66.4941 2.41626L39.541 22.6311C38.9551 23.0706 38.9551 23.803 39.248 24.2424C39.541 24.5354 39.834 24.6819 40.2734 24.6819ZM74.5508 29.3694H2.04102C1.30859 29.3694 0.869141 29.9553 0.869141 30.5413C0.869141 31.2737 1.30859 31.7131 2.04102 31.7131H74.5508C75.1367 31.7131 75.7227 31.2737 75.7227 30.5413C75.7227 29.9553 75.2832 29.3694 74.5508 29.3694ZM71.0352 36.4006C70.3027 36.4006 69.8633 36.9866 69.8633 37.719C69.8633 48.7053 63.125 58.5198 52.7246 62.6213C52.1387 62.9143 51.8457 63.7932 52.2852 64.5256C54.1895 66.8694 55.3613 69.6526 55.8008 72.5823C55.9473 73.3147 55.3613 73.9006 54.6289 73.9006H21.9629C21.2305 73.9006 20.6445 73.3147 20.6445 72.5823C21.084 69.6526 22.2559 66.8694 24.1602 64.5256C24.5996 63.7932 24.3066 62.9143 23.7207 62.6213C13.3203 58.5198 6.58203 48.7053 6.58203 37.5725C6.58203 36.9866 5.99609 36.4006 5.41016 36.4006C4.67773 36.4006 4.23828 36.9866 4.23828 37.5725C4.23828 49.1448 10.8301 59.5452 21.377 64.2327C19.7656 66.7229 18.7402 69.3596 18.3008 72.1428C18.1543 73.3147 18.4473 74.3401 19.1797 75.0725C19.9121 75.8049 20.9375 76.2444 21.9629 76.2444H54.6289C55.6543 76.2444 56.6797 75.8049 57.2656 75.0725C57.998 74.3401 58.291 73.3147 58.1445 72.1428C57.7051 69.3596 56.6797 66.7229 55.2148 64.2327C65.6152 59.5452 72.207 49.1448 72.207 37.5725C72.207 36.9866 71.7676 36.4006 71.0352 36.4006Z"
          fill="#ABA0DB"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="180"
        height="164"
        viewBox="0 0 180 164"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M157.679 25.0067C169.545 36.8872 178.304 52.4555 179.582 69.0485C180.836 85.3144 171.292 99.5944 164.565 114.37C157.675 129.502 153.71 147.326 139.779 156.475C125.707 165.716 107.398 163.406 90.4254 163.059C73.3052 162.71 55.0592 163.968 40.745 154.451C26.3985 144.913 20.3478 127.65 13.5185 111.925C6.7062 96.2395 -1.97097 79.9938 1.16822 63.3225C4.28417 46.7747 17.6214 34.5267 30.198 23.3462C41.7837 13.0467 55.2052 5.09389 70.4417 1.73923C85.2966 -1.5314 100.448 0.680565 115.233 4.62395C130.695 8.74796 146.365 13.6798 157.679 25.0067Z"
          fill="#F1EDF7"
        />
      </svg>
    ),
    gradient: {
      start: "#DED7F4",
      stop: "#F1EDF7",
    },
  },
  "diets-nutrition": {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 81 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M30.5391 9.29089L29.3672 8.70496C27.9023 7.67957 25.998 7.09363 24.0938 7.09363C18.9668 7.09363 14.7188 10.7557 13.6934 15.5897L13.5469 16.6151L12.5215 16.4686C12.375 16.4686 12.375 16.4686 12.2285 16.4686C7.83398 16.4686 4.02539 20.2772 4.02539 24.6718C4.02539 25.8436 4.31836 26.869 4.75781 27.7479C4.9043 28.4803 4.61133 29.0663 4.02539 29.3593C3.43945 29.6522 2.70703 29.3593 2.56055 28.6268C1.97461 27.455 1.68164 26.1366 1.68164 24.6718C1.68164 19.1053 6.07617 14.5643 11.6426 14.2714C13.1074 8.85144 18.0879 4.74988 23.9473 4.74988C25.998 4.74988 27.9023 5.33582 29.5137 6.06824C31.8574 2.55261 35.8125 0.0623779 40.3535 0.0623779C45.041 0.0623779 48.9961 2.55261 51.3398 6.06824C52.9512 5.33582 54.8555 4.74988 56.9062 4.74988C62.7656 4.74988 67.7461 8.85144 69.2109 14.2714C74.7773 14.5643 79.1719 19.1053 79.1719 24.6718C79.1719 26.1366 78.8789 27.455 78.293 28.6268C78.1465 29.3593 77.4141 29.6522 76.8281 29.3593C76.2422 29.0663 75.9492 28.4803 76.0957 27.7479C76.5352 26.869 76.8281 25.8436 76.8281 24.6718C76.8281 20.2772 73.0195 16.4686 68.625 16.4686C68.4785 16.4686 68.4785 16.4686 68.332 16.4686L67.3066 16.6151L67.1602 15.5897C66.1348 10.7557 61.8867 7.09363 56.9062 7.09363C54.8555 7.09363 52.9512 7.67957 51.4863 8.70496L50.3145 9.29089L49.7285 8.11902C47.9707 4.74988 44.4551 2.40613 40.3535 2.40613C36.3984 2.40613 32.8828 4.74988 31.125 8.11902L30.5391 9.29089ZM76.2422 32.8749C78.4395 32.8749 80.3438 34.7792 80.3438 36.9764C80.3438 47.6698 73.3125 56.7518 63.6445 59.828C63.791 60.2675 63.9375 60.7069 63.9375 60.9999C63.9375 63.6366 61.7402 65.6874 59.25 65.6874H21.75C19.1133 65.6874 17.0625 63.6366 17.0625 60.9999C17.0625 60.7069 17.0625 60.2675 17.209 59.828C7.54102 56.7518 0.65625 47.6698 0.65625 36.9764C0.65625 34.7792 2.41406 32.8749 4.61133 32.8749H76.2422ZM19.4062 60.9999C19.4062 62.3182 20.4316 63.3436 21.75 63.3436H59.25C60.4219 63.3436 61.5938 62.3182 61.5938 60.9999C61.5938 60.8534 61.4473 60.7069 61.4473 60.4139C61.1543 59.2421 61.7402 58.0702 62.9121 57.6307C71.7012 54.8475 78 46.6444 78 36.9764C78 36.0975 77.1211 35.2186 76.2422 35.2186H4.61133C3.73242 35.2186 3 36.0975 3 36.9764C3 46.6444 9.15234 54.8475 17.9414 57.6307C19.1133 58.0702 19.6992 59.2421 19.4062 60.4139C19.4062 60.7069 19.4062 60.8534 19.4062 60.9999Z"
          fill="#E7B96D"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="175"
        height="175"
        viewBox="0 0 175 175"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.569606 69.0048C2.70698 52.3496 9.66306 35.8967 22.006 24.7335C34.1055 13.7904 51.2402 12.6031 67.0437 8.88434C83.228 5.07597 99.7526 -2.69202 115.513 2.73016C131.432 8.20713 140.806 24.1029 150.916 37.7405C161.114 51.4967 173.273 65.1591 174.502 82.3045C175.734 99.4885 165.782 114.836 157.521 129.858C149.281 144.844 141.74 161.647 126.632 169.363C111.636 177.023 93.7883 173.966 77.2499 170.858C62.0147 167.996 47.5126 162.245 35.5372 152.245C23.8618 142.496 16.342 129.158 10.4156 115.05C4.21781 100.296 -1.46817 84.884 0.569606 69.0048Z"
          fill="#FEF8EB"
        />
      </svg>
    ),
    gradient: {
      start: "#FFEDD2",
      stop: "#FEF8EB",
    },
  },
  heartworm: {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 80 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M70.9688 32.875H55.2949L50.9004 24.2324C50.6074 23.793 50.3145 23.6465 49.7285 23.5C49.2891 23.6465 48.9961 23.793 48.7031 24.2324L40.5 42.6895L32.1504 19.6914C32.0039 19.252 31.5645 18.8125 30.9785 18.8125C30.5391 18.8125 30.0996 19.252 29.9531 19.6914L25.5586 32.875H9.88477C9.29883 32.875 8.71289 33.4609 8.71289 34.0469C8.71289 34.7793 9.29883 35.2188 9.88477 35.2188H26.291C26.877 35.2188 27.3164 34.9258 27.4629 34.4863L31.125 23.6465L39.3281 46.2051C39.4746 46.6445 39.9141 46.9375 40.3535 46.9375C40.793 46.9375 41.3789 46.791 41.5254 46.3516L49.875 27.4551L53.3906 34.6328C53.6836 35.0723 54.123 35.2188 54.5625 35.2188H70.9688C71.5547 35.2188 72.1406 34.7793 72.1406 34.0469C72.1406 33.4609 71.5547 32.875 70.9688 32.875ZM70.8223 4.60352C67.1602 1.52734 62.9121 0.0625 58.3711 0.0625C52.9512 0.0625 47.3848 2.40625 43.2832 6.50781L40.5 9.58398L37.5703 6.50781C33.4688 2.40625 27.9023 0.0625 22.4824 0.0625C18.0879 0.0625 13.6934 1.52734 10.0312 4.60352C2.56055 11.0488 0.949219 21.7422 5.19727 29.9453C5.34375 30.3848 5.7832 30.5312 6.22266 30.5312C7.10156 30.5312 7.6875 29.6523 7.24805 28.9199C5.7832 26.1367 5.05078 22.9141 5.19727 19.6914C5.49023 14.418 7.6875 9.73047 11.6426 6.36133C14.5723 3.87109 18.3809 2.40625 22.4824 2.40625C27.4629 2.40625 32.2969 4.60352 35.8125 8.26562L40.3535 12.9531L45.041 8.26562C48.5566 4.60352 53.3906 2.40625 58.3711 2.40625C62.4727 2.40625 66.2812 3.87109 69.2109 6.36133C73.166 9.73047 75.3633 14.418 75.6562 19.6914C75.8027 22.9141 75.0703 26.1367 73.6055 28.9199C73.166 29.6523 73.752 30.5312 74.6309 30.5312C75.0703 30.5312 75.5098 30.3848 75.6562 29.9453C79.9043 21.7422 78.293 11.0488 70.8223 4.60352ZM64.6699 39.9062H64.5234C64.2305 39.9062 63.9375 40.0527 63.791 40.3457L42.1113 62.7578C41.6719 63.1973 41.0859 63.3438 40.3535 63.3438C39.6211 63.3438 39.0352 63.1973 38.5957 62.7578L17.0625 40.3457C16.916 40.0527 16.623 39.9062 16.1836 39.9062C15.1582 39.9062 14.5723 41.2246 15.3047 41.957L36.9844 64.3691C38.0098 65.248 39.1816 65.6875 40.3535 65.6875C41.5254 65.6875 42.6973 65.248 43.7227 64.3691L65.4023 41.957C66.1348 41.2246 65.6953 39.9062 64.6699 39.9062Z"
          fill="#E9C4EA"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="162"
        height="174"
        viewBox="0 0 162 174"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M31.1194 17.5419C43.598 7.10151 59.3888 -0.0169033 75.553 0.18098C91.3985 0.374962 104.43 10.8308 118.173 18.6076C132.248 26.5718 149.17 31.9432 156.873 46.195C164.653 60.5907 160.905 78.0831 159.166 94.4536C157.412 110.966 157.123 128.706 146.729 141.716C136.312 154.754 119.105 159.11 103.323 164.351C87.5788 169.578 71.1392 176.56 55.2644 172.086C39.5072 167.646 28.7561 153.7 18.9753 140.581C9.96524 128.497 3.37802 114.841 1.39082 99.8279C-0.546606 85.1913 2.84642 70.7421 7.88485 56.7962C13.1541 42.2115 19.2222 27.4958 31.1194 17.5419Z"
          fill="#FDF9FD"
        />
      </svg>
    ),
    gradient: {
      start: "rgba(233, 196, 234, 0.31)",
      stop: "#FDF9FD",
    },
  },
  "arthritis-pain": {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 85 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M78.5352 22.2637C82.3438 20.3594 84.6875 16.6973 84.6875 12.4492V11.8633C84.6875 6.73633 81.1719 1.90234 76.0449 0.730469C75.3125 0.583984 74.4336 0.4375 73.7012 0.4375C69.0137 0.4375 64.9121 3.51367 63.3008 7.9082V8.05469C62.5684 10.5449 60.2246 12.1562 57.5879 12.1562H27.2656C24.6289 12.1562 22.2852 10.5449 21.5527 7.9082C19.9414 3.51367 15.8398 0.4375 11.1523 0.4375C10.4199 0.4375 9.54102 0.583984 8.80859 0.730469C3.68164 1.90234 0.3125 6.73633 0.3125 11.8633V12.4492C0.3125 16.6973 2.50977 20.3594 6.31836 22.2637C7.63672 22.9961 7.63672 24.9004 6.31836 25.6328C2.50977 27.3906 0.3125 31.1992 0.3125 35.3008V36.0332C0.3125 41.1602 3.68164 45.9941 8.80859 47.166C9.54102 47.3125 10.4199 47.3125 11.1523 47.3125C15.8398 47.3125 19.9414 44.3828 21.5527 39.9883V39.8418C22.2852 37.3516 24.6289 35.5938 27.2656 35.5938H57.5879C60.2246 35.5938 62.5684 37.3516 63.3008 39.8418C63.3008 39.8418 63.3008 39.9883 63.4473 39.9883C64.9121 44.3828 69.0137 47.3125 73.7012 47.3125C74.4336 47.3125 75.3125 47.3125 76.0449 47.166C81.1719 45.9941 84.6875 41.1602 84.6875 36.0332V35.4473C84.6875 31.1992 82.3438 27.3906 78.5352 25.6328C77.2168 24.9004 77.2168 22.9961 78.5352 22.2637ZM77.5098 27.6836C80.4395 29.1484 82.3438 32.0781 82.3438 35.3008V36.0332C82.3438 40.2812 79.4141 43.9434 75.6055 44.8223C75.0195 44.9688 74.2871 44.9688 73.7012 44.9688C70.0391 44.9688 66.8164 42.625 65.6445 39.1094C64.4727 35.5938 61.25 33.25 57.5879 33.25H27.2656C23.6035 33.25 20.3809 35.5938 19.209 39.2559C18.0371 42.625 14.8145 44.9688 11.1523 44.9688C10.5664 44.9688 9.83398 44.9688 9.24805 44.8223C5.43945 43.9434 2.65625 40.2812 2.65625 36.0332V35.4473C2.65625 32.0781 4.41406 29.1484 7.34375 27.6836C8.80859 26.9512 9.6875 25.4863 9.6875 23.875C9.6875 22.4102 8.80859 20.9453 7.34375 20.2129C4.41406 18.748 2.65625 15.8184 2.65625 12.4492V11.8633C2.65625 7.61523 5.43945 3.95312 9.24805 3.07422C9.83398 2.92773 10.5664 2.78125 11.1523 2.78125C14.8145 2.78125 18.0371 5.27148 19.209 8.78711C20.3809 12.1562 23.6035 14.5 27.2656 14.5H57.5879C61.25 14.5 64.4727 12.3027 65.6445 8.64062C66.8164 5.125 70.0391 2.78125 73.7012 2.78125C74.2871 2.78125 75.0195 2.92773 75.6055 3.07422C79.4141 3.95312 82.3438 7.61523 82.3438 11.8633V12.4492C82.3438 15.8184 80.4395 18.748 77.5098 20.2129C76.0449 20.9453 75.166 22.2637 75.166 23.875C75.166 25.4863 76.0449 26.9512 77.5098 27.6836Z"
          fill="#8CBAE3"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="174"
        height="176"
        viewBox="0 0 174 176"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M78.3478 1.4628C94.9647 -0.954751 112.682 1.32349 126.752 10.212C140.544 18.9253 146.293 35.1105 154.122 49.3331C162.14 63.8983 174.063 77.7272 173.076 94.3646C172.079 111.17 159.288 124.472 148.869 137.875C138.36 151.395 128.468 166.778 112.284 172.57C96.0631 178.375 78.6058 172.914 61.9158 168.995C45.2672 165.086 27.0555 162.337 15.5626 149.86C4.15473 137.474 2.30171 119.461 0.850368 102.696C-0.486613 87.252 1.15511 71.7379 7.56843 57.5155C13.8211 43.6495 24.6471 32.8216 36.6429 23.3217C49.1881 13.3867 62.5053 3.7677 78.3478 1.4628Z"
          fill="#F4F8FC"
        />
      </svg>
    ),
    gradient: {
      start: "#e2ecf6",
      stop: "#F4F8FC",
    },
  },
  antibiotics: {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 576 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M529.1 206.9C497.9 175.6 456.9 160 416 160s-81.95 15.61-113.2 46.85c-62.48 62.48-62.48 163.8 0 226.3C334 464.4 375.1 480 416 480s81.89-15.6 113.1-46.84C591.6 370.7 591.6 269.3 529.1 206.9zM416 464c-38.46 0-74.63-14.98-101.8-42.18C286.1 394.6 272 358.5 272 320c0-35.75 13.41-69.2 37.08-95.62l202.5 202.6C485.2 450.6 451.7 464 416 464zM522.9 415.6l-202.5-202.6C346.8 189.4 380.3 176 416 176c38.46 0 74.63 14.98 101.8 42.18C545 245.4 560 281.5 560 320C560 355.8 546.6 389.2 522.9 415.6zM112 32C50.15 32 0 82.14 0 143.1v223.1c0 61.86 50.15 111.1 112 111.1s112-50.14 112-111.1V143.1C224 82.14 173.9 32 112 32zM208 368c0 52.94-43.06 96-96 96s-96-43.06-96-96V264h192V368zM208 248h-192V144c0-52.94 43.06-96 96-96s96 43.06 96 96V248z"
          fill="#E7B96D"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#FFF8EB"
        />
      </svg>
    ),
    gradient: {
      start: "#FFEDD2",
      stop: "#FBF3E4",
    },
  },
  supplements: {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 320 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M152 224H128C83.82 224 48 188.2 48 144C48 135.2 55.16 128 64 128H88C119.7 128 147 146.4 160 173.1C172.1 146.4 200.3 128 232 128H256C264.8 128 272 135.2 272 144C272 188.2 236.2 224 192 224H168C165.1 224 162.4 223.2 160 221.9C157.6 223.2 154.9 224 152 224zM256 144H232C196.7 144 168 172.7 168 208H192C227.3 208 256 179.3 256 144zM152 208C152 172.7 123.3 144 88 144H64C64 179.3 92.65 208 128 208H152zM168 328C165.1 328 162.4 327.2 160 325.9C157.6 327.2 154.9 328 152 328H128C83.82 328 48 292.2 48 248C48 239.2 55.16 232 64 232H88C119.7 232 147 250.4 160 277.1C172.1 250.4 200.3 232 232 232H256C264.8 232 272 239.2 272 248C272 292.2 236.2 328 192 328H168zM168 312H192C227.3 312 256 283.3 256 248H232C196.7 248 168 276.7 168 312zM64 248C64 283.3 92.65 312 128 312H152C152 276.7 123.3 248 88 248H64zM168 432V456C168 460.4 164.4 464 160 464C155.6 464 152 460.4 152 456V432H128C83.82 432 48 396.2 48 352C48 343.2 55.16 336 64 336H88C119.7 336 147 354.4 160 381.1C172.1 354.4 200.3 336 232 336H256C264.8 336 272 343.2 272 352C272 396.2 236.2 432 192 432H168zM256 352H232C196.7 352 168 380.7 168 416H192C227.3 416 256 387.3 256 352zM64 352C64 387.3 92.65 416 128 416H152C152 380.7 123.3 352 88 352H64zM48 32C48 14.33 62.33 0 80 0H240C257.7 0 272 14.33 272 32V66.02C299.6 73.12 320 98.18 320 128V448C320 483.3 291.3 512 256 512H64C28.65 512 0 483.3 0 448V128C0 98.18 20.4 73.12 48 66.02V32zM240 16H80C71.16 16 64 23.16 64 32V64H256V32C256 23.16 248.8 16 240 16zM16 128V448C16 474.5 37.49 496 64 496H256C282.5 496 304 474.5 304 448V128C304 101.5 282.5 80 256 80H64C37.49 80 16 101.5 16 128z"
          fill="#9bbfbf"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#e4f2f2"
        />
      </svg>
    ),
    gradient: {
      start: "#cfe6e6",
      stop: "#e4f2f2",
    },
  },
  dental: {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 448 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M393.5 219c-15.1 22.19-25.03 49.72-28.43 86.64c-2.969 32.94-7.623 76.32-17.28 119.5l-6.467 28.6C337.1 468.9 324.5 480 309.2 480c-15.21 0-28.37-10.55-31.99-25.66l-28.31-114.2c-2.967-11.89-13.18-20.19-24.9-20.19c-11.81 0-22.03 8.281-24.87 20.12l-28.37 114.3C167.2 469.5 154 480 138.8 480c-15.46 0-28.71-10.8-32.24-26.27l-6.375-28.61c-9.467-42.22-14.09-84.07-17.4-119.4C79.52 268.8 70.52 241.3 54.46 219C33.84 190.3 27.13 154.9 35.53 119.4C45.21 78.42 77.12 45.06 116.8 34.4c19.31-5.109 39.77-1.891 60.74 9.424l83.17 54.89c3.688 2.438 4.719 7.391 2.281 11.08c-2.5 3.719-7.467 4.688-11.09 2.266L169.4 57.54C152.4 48.46 136.4 45.79 120.9 49.85c-34.05 9.156-61.49 37.89-69.83 73.21c-7.312 30.97-1.5 61.74 16.37 86.61c17.81 24.72 27.74 54.77 31.24 94.57c3.248 34.81 7.811 76.04 17.09 117.4l6.373 28.6c1.844 8.094 8.686 13.77 16.62 13.77c7.779 0 14.56-5.5 16.44-13.38l28.37-114.3c4.531-19.02 21.15-32.35 40.4-32.35c19.09 0 35.71 13.3 40.43 32.35l28.31 114.2c1.906 7.938 8.686 13.44 16.46 13.44c7.842 0 14.78-5.781 16.53-13.75l6.469-28.63c9.467-42.22 14.03-84.93 16.96-117.4c3.686-39.89 13.65-69.94 31.37-94.55c17.9-24.8 23.71-55.57 16.37-86.61c-8.342-35.31-35.78-64.05-69.86-73.22c-20.46-5.438-42.02 .875-66.3 19.22c-3.498 2.656-8.529 1.984-11.19-1.547c-2.654-3.531-1.967-8.547 1.562-11.2c28.03-21.21 54.93-28.61 80.05-21.92c39.71 10.67 71.61 44.03 81.29 84.99C420.9 155 414.2 190.4 393.5 219z"
          fill="#8fb2d6"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#f0f5f9"
        />
      </svg>
    ),
    gradient: {
      start: "#dde9f3",
      stop: "#f0f5f9",
    },
  },
  "dental-health": {
    Icon: (props: SVGProps) => (
      <svg viewBox="0 0 448 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M393.5 219c-15.1 22.19-25.03 49.72-28.43 86.64c-2.969 32.94-7.623 76.32-17.28 119.5l-6.467 28.6C337.1 468.9 324.5 480 309.2 480c-15.21 0-28.37-10.55-31.99-25.66l-28.31-114.2c-2.967-11.89-13.18-20.19-24.9-20.19c-11.81 0-22.03 8.281-24.87 20.12l-28.37 114.3C167.2 469.5 154 480 138.8 480c-15.46 0-28.71-10.8-32.24-26.27l-6.375-28.61c-9.467-42.22-14.09-84.07-17.4-119.4C79.52 268.8 70.52 241.3 54.46 219C33.84 190.3 27.13 154.9 35.53 119.4C45.21 78.42 77.12 45.06 116.8 34.4c19.31-5.109 39.77-1.891 60.74 9.424l83.17 54.89c3.688 2.438 4.719 7.391 2.281 11.08c-2.5 3.719-7.467 4.688-11.09 2.266L169.4 57.54C152.4 48.46 136.4 45.79 120.9 49.85c-34.05 9.156-61.49 37.89-69.83 73.21c-7.312 30.97-1.5 61.74 16.37 86.61c17.81 24.72 27.74 54.77 31.24 94.57c3.248 34.81 7.811 76.04 17.09 117.4l6.373 28.6c1.844 8.094 8.686 13.77 16.62 13.77c7.779 0 14.56-5.5 16.44-13.38l28.37-114.3c4.531-19.02 21.15-32.35 40.4-32.35c19.09 0 35.71 13.3 40.43 32.35l28.31 114.2c1.906 7.938 8.686 13.44 16.46 13.44c7.842 0 14.78-5.781 16.53-13.75l6.469-28.63c9.467-42.22 14.03-84.93 16.96-117.4c3.686-39.89 13.65-69.94 31.37-94.55c17.9-24.8 23.71-55.57 16.37-86.61c-8.342-35.31-35.78-64.05-69.86-73.22c-20.46-5.438-42.02 .875-66.3 19.22c-3.498 2.656-8.529 1.984-11.19-1.547c-2.654-3.531-1.967-8.547 1.562-11.2c28.03-21.21 54.93-28.61 80.05-21.92c39.71 10.67 71.61 44.03 81.29 84.99C420.9 155 414.2 190.4 393.5 219z"
          fill="#8fb2d6"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#f0f5f9"
        />
      </svg>
    ),
    gradient: {
      start: "#dde9f3",
      stop: "#f0f5f9",
    },
  },
  "pet-essentials": {
    Icon: (props: SVGProps) => <Icon color="#F3DE7F" {...props} icon={faTennisBall} />,
    Blob: (props: SVGProps) => (
      <svg
        width="175"
        height="175"
        viewBox="0 0 175 175"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.569606 69.0048C2.70698 52.3496 9.66306 35.8967 22.006 24.7335C34.1055 13.7904 51.2402 12.6031 67.0437 8.88434C83.228 5.07597 99.7526 -2.69202 115.513 2.73016C131.432 8.20713 140.806 24.1029 150.916 37.7405C161.114 51.4967 173.273 65.1591 174.502 82.3045C175.734 99.4885 165.782 114.836 157.521 129.858C149.281 144.844 141.74 161.647 126.632 169.363C111.636 177.023 93.7883 173.966 77.2499 170.858C62.0147 167.996 47.5126 162.245 35.5372 152.245C23.8618 142.496 16.342 129.158 10.4156 115.05C4.21781 100.296 -1.46817 84.884 0.569606 69.0048Z"
          fill="#FFFCEC"
        />
      </svg>
    ),
    gradient: {
      start: "#FFF8CD",
      stop: "#FFFCEC",
    },
  },
  shampoos: {
    Icon: (props: SVGProps) => <Icon color="#ABA0DB" {...props} icon={faShower} />,
    Blob: (props: SVGProps) => (
      <svg
        width="180"
        height="164"
        viewBox="0 0 180 164"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M157.679 25.0067C169.545 36.8872 178.304 52.4555 179.582 69.0485C180.836 85.3144 171.292 99.5944 164.565 114.37C157.675 129.502 153.71 147.326 139.779 156.475C125.707 165.716 107.398 163.406 90.4254 163.059C73.3052 162.71 55.0592 163.968 40.745 154.451C26.3985 144.913 20.3478 127.65 13.5185 111.925C6.7062 96.2395 -1.97097 79.9938 1.16822 63.3225C4.28417 46.7747 17.6214 34.5267 30.198 23.3462C41.7837 13.0467 55.2052 5.09389 70.4417 1.73923C85.2966 -1.5314 100.448 0.680565 115.233 4.62395C130.695 8.74796 146.365 13.6798 157.679 25.0067Z"
          fill="#F1EDF7"
        />
      </svg>
    ),
    gradient: {
      start: "#DED7F4",
      stop: "#F1EDF7",
    },
  },
  "eye-care": {
    Icon: (props: SVGProps) => <Icon color="#8CBAE3" {...props} icon={faEye} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#F4F8FC"
        />
      </svg>
    ),
    gradient: {
      start: "#e2ecf6",
      stop: "#F4F8FC",
    },
  },
  "equine-therapeutics": {
    Icon: (props: SVGProps) => <Icon color="#E89BA0" {...props} icon={faSyringe} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#FDF6F6"
        />
      </svg>
    ),
    gradient: {
      start: "#FAEAEA",
      stop: "#FDF6F6",
    },
  },
  "equine-musculoskeletal-support": {
    Icon: (props: SVGProps) => <Icon color="#D4B896" {...props} icon={faBone} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#FAF7F2"
        />
      </svg>
    ),
    gradient: {
      start: "#F5EFE5",
      stop: "#FAF7F2",
    },
  },
  "equine-parasite-control": {
    Icon: (props: SVGProps) => <Icon color="#CC7E5C" {...props} icon={faBugs} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#FEF5F2"
        />
      </svg>
    ),
    gradient: {
      start: "#FFEAE9",
      stop: "#FEF5F2",
    },
  },
  "general-equine-care": {
    Icon: (props: SVGProps) => <Icon color="#9bbfbf" {...props} icon={faHorseHead} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#e4f2f2"
        />
      </svg>
    ),
    gradient: {
      start: "#cfe6e6",
      stop: "#e4f2f2",
    },
  },
  "equine-nutritional-support": {
    Icon: (props: SVGProps) => <Icon color="#E9924C" {...props} icon={faCarrot} />,
    Blob: (props: SVGProps) => (
      <svg
        width="175"
        height="175"
        viewBox="0 0 175 175"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.569606 69.0048C2.70698 52.3496 9.66306 35.8967 22.006 24.7335C34.1055 13.7904 51.2402 12.6031 67.0437 8.88434C83.228 5.07597 99.7526 -2.69202 115.513 2.73016C131.432 8.20713 140.806 24.1029 150.916 37.7405C161.114 51.4967 173.273 65.1591 174.502 82.3045C175.734 99.4885 165.782 114.836 157.521 129.858C149.281 144.844 141.74 161.647 126.632 169.363C111.636 177.023 93.7883 173.966 77.2499 170.858C62.0147 167.996 47.5126 162.245 35.5372 152.245C23.8618 142.496 16.342 129.158 10.4156 115.05C4.21781 100.296 -1.46817 84.884 0.569606 69.0048Z"
          fill="#FEF8F0"
        />
      </svg>
    ),
    gradient: {
      start: "#FFEEDD",
      stop: "#FEF8F0",
    },
  },
  "equine-internal-health-support": {
    Icon: (props: SVGProps) => <Icon color="#7DB87D" {...props} icon={faStaffSnake} />,
    Blob: (props: SVGProps) => (
      <svg
        width="166"
        height="178"
        viewBox="0 0 166 178"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.8747 33.3613C19.8501 19.1695 33.1073 7.19734 49.0113 2.29582C64.6018 -2.50905 80.6331 3.65569 96.5277 6.9636C112.805 10.3512 131.065 10.2939 143.057 21.8681C155.17 33.5592 156.949 51.9274 160.349 68.5597C163.778 85.3367 169.025 102.857 162.893 118.916C156.748 135.011 141.243 144.715 127.408 154.84C113.607 164.939 99.6715 176.981 82.7182 177.591C65.8905 178.195 51.0059 167.883 37.3301 158.078C24.732 149.045 14.0186 137.704 7.39075 123.58C0.928932 109.811 -0.250136 94.5445 0.340323 79.254C0.957827 63.2632 2.31752 46.8918 10.8747 33.3613Z"
          fill="#F3F9F3"
        />
      </svg>
    ),
    gradient: {
      start: "#E4F2E4",
      stop: "#F3F9F3",
    },
  },
  "equine-dermatologic-hoof-care": {
    Icon: (props: SVGProps) => (
      // Custom since faHorseshoe is not available in pro-thin-svg-icons until v7
      <svg viewBox="0 0 448 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M122.4 0c23.1 0 41 19.4 39.9 41.8l-.5 4.5-32.4 200.8c-1 6.3-1.5 12.7-1.5 19.1l0 5.8c0 53 43 96 96 96s96-43 96-96l0-5.8c0-6.4-.5-12.8-1.5-19.1L286.1 46.4C282.2 22.1 300.9 0 325.6 0L416 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8.2 0 35.8 177 1.9 11.2c1.7 11.2 2.5 22.5 2.5 33.8 0 123.6-100.2 226-224 226S0 409.6 0 286c0-15 1.5-30.2 4.5-45L40.2 64 32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l90.4 0zM32 16c-8.8 0-16 7.2-16 16s7.2 16 16 16l18 0c2.4 0 4.7 1.1 6.2 2.9s2.1 4.3 1.7 6.7L20.2 244.2C17.4 257.9 16 272 16 286 16 401 109.2 496 224 496s208-95 208-210c0-10.5-.8-21.1-2.3-31.5l-1.8-10.3-37.7-186.6c-.5-2.4 .1-4.8 1.7-6.7S395.6 48 398 48l18 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-90.4 0c-14.8 0-26 13.2-23.7 27.8l32.4 200.8c1.2 7.2 1.8 14.4 1.8 21.7l0 5.8c0 61.9-50.1 112-112 112S112 333.9 112 272l0-5.8c0-7.3 .6-14.5 1.8-21.7l32.4-200.8 .3-2.7c.6-13.5-10.1-25.1-24-25.1L32 16z"
          fill="#E9C4EA"
        />
      </svg>
    ),
    Blob: (props: SVGProps) => (
      <svg
        width="162"
        height="174"
        viewBox="0 0 162 174"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M31.1194 17.5419C43.598 7.10151 59.3888 -0.0169033 75.553 0.18098C91.3985 0.374962 104.43 10.8308 118.173 18.6076C132.248 26.5718 149.17 31.9432 156.873 46.195C164.653 60.5907 160.905 78.0831 159.166 94.4536C157.412 110.966 157.123 128.706 146.729 141.716C136.312 154.754 119.105 159.11 103.323 164.351C87.5788 169.578 71.1392 176.56 55.2644 172.086C39.5072 167.646 28.7561 153.7 18.9753 140.581C9.96524 128.497 3.37802 114.841 1.39082 99.8279C-0.546606 85.1913 2.84642 70.7421 7.88485 56.7962C13.1541 42.2115 19.2222 27.4958 31.1194 17.5419Z"
          fill="#FDF9FD"
        />
      </svg>
    ),
    gradient: {
      start: "rgba(233, 196, 234, 0.31)",
      stop: "#FDF9FD",
    },
  },
  "thyroid-hormone": {
    Icon: (props: SVGProps) => <Icon color="#76B4D4" {...props} icon={faAtomSimple} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#F0F7FB"
        />
      </svg>
    ),
    gradient: {
      start: "#DDF0F7",
      stop: "#F0F7FB",
    },
  },
  default: {
    Icon: (props: SVGProps) => <Icon color="#8fb2d6" {...props} icon={faBox} />,
    Blob: (props: SVGProps) => (
      <svg
        width="173"
        height="173"
        viewBox="0 0 173 173"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
          fill="#f0f5f9"
        />
      </svg>
    ),
    gradient: {
      start: "#dde9f3",
      stop: "#f0f5f9",
    },
  },
};

export default CategoryContentLookup;
